import { SelectOption } from 'basics/options/options.types';
import { Format } from 'generated/event.types';

const eventFormatOptions: SelectOption[] = [
  { id: Format.meeting, label: 'Meeting' },
  { id: Format.webinar, label: 'Webinar' },
];

export default eventFormatOptions;
